
export default {
  props: {
    blok: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      seals: null,
      nextSeal: null,
      animationDelay: null,
      animateCycle: false,
      animationCycleFunc: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const mm = this.$gsap.matchMedia(this.$el)

      this.setDefaults()

      // mobile
      mm.add('(max-width: 639px)', () => {
        // kill existing animation
        this.animationCycleFunc?.kill()

        if (!this.blok.disableAnimationOnMobile) {
          this.changeSeal()
        }
      })

      // desktop
      mm.add('(min-width: 640px)', () => {
        // kill existing animation
        this.animationCycleFunc?.kill()

        this.changeSeal()
      })
    })
  },
  methods: {
    setDefaults() {
      // convert string to array - remove spaces
      this.seals = this.blok?.cycleAnimation
        ?.replace(/\s+/g, '')
        ?.split(',') || ['hsr']

      this.nextSeal = this.seals[0]

      // do not cycle if only one seal
      if (this.seals?.length > 1) {
        this.animationDelay = this.blok?.animationDelay || 5
        this.animateCycle = this.seals?.length > 1
      }
    },
    changeSeal() {
      // shift first item to end
      this.seals.push(this.seals.shift())

      this.nextSeal = null
      this.nextSeal = this.seals[0]

      this.animationCycleFunc = this.$gsap.delayedCall(
        this.animationDelay,
        this.changeSeal
      )
    },
  },
}
